import axiosInstance from '@/plugins/axios';

// DCTFWeb via IntegraContador (BFF /dctf) — débito/crédito/saldo/DARF/DCOMP por
// competência (mensal + 13º salário). Substitui o fluxo RPA/.dec anterior.
const ServiceDctf = {
  sincronizar: (cnpj, ano, mes) => axiosInstance.post('dctf/sincronizar', { cnpj, ano, mes }),
  search: (body) => axiosInstance.post('dctf/search', body),
  // POST (não GET): a lista de CNPJs atribuídos pode estourar o limite de URL.
  buscarPeriodosApuracao: (cnpjs) => axiosInstance.post('dctf/periodos-apuracao', { cnpjs }),
  buscarDetalhes: (id, { page, size, chargeCode, sort }) =>
    axiosInstance.get(`dctf/${id}/detalhes`, {
      params: { page, size, ...(chargeCode ? { chargeCode } : {}), sort },
    }),
  buscarEncargos: (id) => axiosInstance.get(`dctf/${id}/encargos`),
};

export default ServiceDctf;
